const url = 'https://newaska-cdn.s3.sa-east-1.amazonaws.com';

export const products = [    
    {
        id: 53020,
        name: "Ta\u00e7as",
        itens: [
            {
                id: 564407,
                name: "Colegial",
                description: "Uma bola de sorvete, chantilly, calda de morango, calda de chocolate, amendoim, morango e bijus.",
                price: "12,00",
                image: `${url}/200518211559.jpg`,
                min_price: false,
            },
            {
                id: 573698,
                name: "Sundae",
                description: "Duas bolas de sorvete, chantilly, calda de morango, calda de chocolate, amendoim, morango e bijus.",
                price: "16,00",
                image: `${url}/200518211607.jpg`,
                min_price: false,
            },
            {
                id: 564421,
                name: "Salada de frutas",
                description: "Salada de frutas 300 ml (mam\u00e3o, banana, mel\u00e3o, morango, abacaxi, ma\u00e7\u00e3 e suco de laranja).",
                price: "10,00",
                image: `${url}/200519015809.jpg`,
                min_price: false,
            },
            {
                id: 53020,
                name: "Banana Split",
                description: "Banana, tr\u00eas bolas de sorvete, chantilly, calda de morango, calda de chocolate, amendoim, morangos e bijus.",
                price: "23,00",
                image: `${url}/200519015810.jpg`,
                min_price: false,
            },
            {
                id: 53020,
                name: "Sundae Hawai",
                description: "Meio abacaxi, tr\u00eas bolas de sorvete, chantilly, calda de morango, calda de chocolate, amendoim, morangos e bijus.",
                price: "28,00",
                image: `${url}/200519015815.jpg`,
                min_price: false,
            },
            {
                id: 781135,
                name: "Calif\u00f3rnia",
                description: "Duas bolas de sorvete de flocos, suco de laranja, chantilly, calda de chocolate, morango e bijus.",
                price: "16,00",
                image: `${url}/200519015822.jpg`,
                min_price: false,
            },
            {
                id: 572775,
                name: "Morango com chantily",
                description: "Morangos, uma bola de sorvete, Nutella, chantilly, calda de morango, m&m's e bijus.",
                price: "16,00",
                image: `${url}/200519015823.jpg`,
                min_price: false,
            },
            {
                id: 565177,
                name: "Milk Encanto",
                description: "Calda de chocolate, milk shake de Ovomaltine, uma bola de sorvete de chocolate branco, chantilly, Bis e bijus.",
                price: "20,00",
                image: `${url}/200519015824.jpg`,
                min_price: false,
            },
            {
                id: 565180,
                name: "Milk Oreo",
                description: "Milk shake de Oreo com chantilly, bolacha Oreo e bijus.",
                price: "20,00",
                image: `${url}/200519015825.jpg`,
                min_price: false,
            },
            {
                id: 565170,
                name: "Milk Nutella",
                description: "Calda de chocolate, milk shake de Nutella, bolinhas de cereal com chocolate, Nutella, chantilly, Bis e bijus.",
                price: "22,00",
                image: `${url}/200519015826.jpg`,
                min_price: false,
            },
            {
                id: 565170,
                name: "Ta\u00e7a Ferrero",
                description: "Calda de chocolate, duas bolas de sorvete de ferrero rocher, calda de avel\u00e3, borda de Nutella com amendoim, chantilly, bombom ferrero rocher e bijus.",
                price: "25,00",
                image: `${url}/200519015827.jpg`,
                min_price: false,
            },
            {
                id: 573705,
                name: "Ta\u00e7a Kinder",
                description: "Chocolate, duas bolas de sorvete Kinder ovo, chantilly, Kinder ovo e bijus.",
                price: "25,00",
                image: `${url}/200519015828.jpg`,
                min_price: false,
            },
        ],
    },
    {
        id: 96846,
        name: "Sorvete expresso",
        itens: [
            {
                id: 573876,
                name: "Mega Sundae",
                description: "Sorvete expresso, com 01 calda e 01 recheio de sua escolha!",
                price: "10,00",
                image: `${url}/200519015335.jpg`,
                min_price: false,
            },
            {
                id: 573901,
                name: "Especial Negresco",
                description: "Sorvete expresso, calda de chocolate e bolacha Negresco em peda\u00e7os.",
                price: "12,00",
                image: `${url}/200519015344.jpg`,
                min_price: false,
            },
            {
                id: 573906,
                name: "Especial chocolate ao leite",
                description: "Sorvete expresso, calda de chocolate e peda\u00e7os de chocolate ao leite.",
                price: "12,00",
                image: `${url}/200519015351.jpg`,
                min_price: false,
            },
            {
                id: 573909,
                name: "Especial Ouro Branco",
                description: "Sorvete expresso, calda de chocolate branco e bombom Ouro Branco em peda\u00e7os.",
                price: "12,00",
                image: `${url}/200519015402.jpg`,
                min_price: false,
            },
            {
                id: 573929,
                name: "Expresso Nutella",
                description: "Sorvete expresso, Nutella e cookie em peda\u00e7os.",
                price: "14,00",
                image: `${url}/200519015411.jpg`,
                min_price: false,
            },
            {
                id: 573936,
                name: "Super mix Charge",
                description: "Sorvete expresso, calda de chocolate e amendoim e bombom charge.",
                price: "14,00",
                image: `${url}/200519015419.jpg`,
                min_price: false,
            },
            {
                id: 573944,
                name: "Super mix Kinder Bueno",
                description: "Sorvete expresso, calda de chocolate preto e branco e bombom Kinder bueno.",
                price: "14,00",
                image: `${url}/200519015428.jpg`,
                min_price: false,
            },
            {
                id: 573959,
                name: "Super fruta Abacaxi ao vinho",
                description: "Sorvete expresso, calda de abacaxi ao vinho e abacaxi em peda\u00e7os.",
                price: "12,00",
                image: `${url}/200519015436.jpg`,
                min_price: false,
            },
            {
                id: 573970,
                name: "Super fruta Frutas vermelhas",
                description: "Sorvete expresso, calda de frutas vermelhas e morango em peda\u00e7os.",
                price: "12,00",
                image: `${url}/200519015448.jpg`,
                min_price: false,
            },
            {
                id: 573978,
                name: "Sensa\u00e7\u00e3o",
                description: "Sorvete expresso, leite condensado, leite Ninho e morango em peda\u00e7os.",
                price: "12,00",
                image: `${url}/200519015454.jpg`,
                min_price: false,
            },           
        ],
    },
    {
        id: 96871,
        name: "Milk shake",
        itens: [
            {
                id: 573994,
                name: "Milk shake 300 ml",
                description: "",
                price: "10,00",
                image: `${url}/200518213333.jpg`,
                min_price: false,
            },
            {
                id: 573996,
                name: "Milk shake 400 ml",
                description: "",
                price: "11,00",
                image: `${url}/200518213411.jpg`,
                min_price: false,
            },
            {
                id: 573997,
                name: "Milk shake 500 ml",
                description: "",
                price: "12,00",
                image: `${url}/200518213417.jpg`,
                min_price: false,
            },
            {
                id: 573999,
                name: "Milk shake 700 ml",
                description: "",
                price: "15,00",
                image: `${url}/200518213423.jpg`,
                min_price: false,
            },
            {
                id: 574012,
                name: "Milk shake especial",
                description: "Milk shake especial com chantilly",
                price: "16,00",
                image: `${url}/200519015905.jpg`,
                min_price: false,
            },
        ],
    },
    {
        id: 96875,
        name: "A\u00e7a\u00ed",
        itens: [            
            {
                id: 96871,
                name: "Copo a\u00e7a\u00ed 300 ml",
                description: "A\u00e7a\u00ed com 2 acompanhamentos",
                price: "10,00",
                image: `${url}/200827140446.jpg`,
                min_price: false,
            },
            {
                id: 96872,
                name: "Copo a\u00e7a\u00ed 400 ml",
                description: "A\u00e7a\u00ed com 2 acompanhamentos",
                price: "11,00",
                image: `${url}/200827140446.jpg`,
                min_price: false,
            },
            {
                id: 96873,
                name: "Copo a\u00e7a\u00ed 500 ml",
                description: "A\u00e7a\u00ed com 2 acompanhamentos",
                price: "12,00",
                image: `${url}/200827140446.jpg`,
                min_price: false,
            },
            {
                id: 96874,
                name: "Copo a\u00e7a\u00ed 700 ml",
                description: "A\u00e7a\u00ed com 2 acompanhamentos",
                price: "15,00",
                image: `${url}/200827140446.jpg`,
                min_price: false,
            },
            {
                id: 574177,
                name: "Ta\u00e7a de a\u00e7a\u00ed",
                description: "",
                price: "22,00",
                image: `${url}/200518213444.jpg`,
                min_price: false,
            },
            {
                id: 574184,
                name: "Pote a\u00e7a\u00ed 1 litro",
                description: "O seu a\u00e7a\u00ed preferido!",
                price: "22,00",
                image: `${url}/200518213610.jpg`,
                min_price: false,
            },    
            {
                id: 574185,
                name: "Pote a\u00e7a\u00ed 5 litros",
                description: "O seu a\u00e7a\u00ed preferido!",
                price: "80,00",
                image: `${url}/200518574185.jpg`,
                min_price: false,
            },    
            {
                id: 574186,
                name: "Pote a\u00e7a\u00ed 10 litros",
                description: "O seu a\u00e7a\u00ed preferido!",
                price: "150,00",
                image: `${url}/200518574185.jpg`,
                min_price: false,
            },      
        ],
    },
    {
        id: 96907,
        name: "Sorvete em pote",
        itens: [
            {
                id: 574197,
                name: "Pote 1 litro",
                description: "",
                price: "7,00",
                image: `${url}/200519015944.jpg`,
                min_price: true,
            },
            {
                id: 574207,
                name: "Pote 1 litro especial",
                description: "",
                price: "8,50",
                image: `${url}/200519015949.jpg`,
                min_price: false,
            },
            {
                id: 579243,
                name: "Pote 2 litros",
                description: "",
                price: "12,90",
                image: `${url}/200519015957.jpg`,
                min_price: false,
            },
            {
                id: 579244,
                name: "Pote 2 litros especial",
                description: "",
                price: "19,90",
                image: `${url}/200519579244.jpg`,
                min_price: false,
            },
            {
                id: 579252,
                name: "Balde 5 litros",
                description: "",
                price: "35,00",
                image: `${url}/200514065902.jpg`,
                min_price: false,
            }, 
            {
                id: 579253,
                name: "Balde 10 litros",
                description: "",
                price: "70,00",
                image: `${url}/200514065902.jpg`,
                min_price: false,
            }, 
            {
                id: 579254,
                name: "Balde 10 litros especial",
                description: "",
                price: "75,00",
                image: `${url}/200514065902.jpg`,
                min_price: false,
            },           
        ],
    },
    {
        id: 96908,
        name: "Picol\u00e9s",
        itens: [
            {
                id: 580950,
                name: "Picol\u00e9 especial",
                description: "",
                price: "3,00",
                image: `${url}/200514065903.jpg`,
                min_price: true,
            },
            {
                id: 580953,
                name: "Paletas",
                description: "",
                price: "5,00",
                image: `${url}/200514065904.jpg`,
                min_price: false,
            },  
        ],
    }
];